import { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { faPenToSquare,faMultiply,faSave, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from '../../../../../styles/fileupload.module.css';
import { useForm } from "react-hook-form";
import ButtonOverride from "../../../../../components/buttonoverride";
import useFileDownload from "../../../../../hooks/use-filedownload";

const smallAddButtonStyle = {
    borderRadius: "50%",
    width: "32px",
    height: "32px",
    minWidth: "32px",
    minHeight: "32px",
    padding: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
};

const ViewMode = ({toggleMode,inspection,remove,ActionTypes = [],InspectionStatuses = [],InspectionTypes = []}) => {
    const selectedType = InspectionTypes.find(item => item.id === inspection.inspectiontype)?.name;
    const selectedStatus = InspectionStatuses.find(item => item.id === inspection.inspectionstatus)?.name;
    const selectedWaiverStatus = ActionTypes.find(item => item.id === inspection.waiverstatus)?.name;

    const downloadFile = useFileDownload();

    return(
        <tr>
            <td className="align-middle">{selectedType}</td>
            <td className="align-middle">{inspection.inspectiondate}</td>
            <td className="align-middle">{selectedStatus}</td>
            <td className="align-middle">
                {
                    inspection.inspectionreport
                    ?
                        inspection.inspectionreport instanceof File
                        ?
                            <a href={URL.createObjectURL(inspection.inspectionreport)} target="_blank" rel="noopener noreferrer" className={styles.addedDoc}>
                                View File
                            </a>
                        :
                            <Button type="button" title="Download File" aria-label="Download File" variant="link" className={styles.addedDoc} onClick={() => downloadFile({FileID: inspection.inspectionreport.id},'DownloadBidInspectionFile',inspection.inspectionreport.name)}>
                                View File
                            </Button>
                    :   
                        <>N/A</>
                }
            </td>
            <td className="align-middle">{inspection.comments}</td>
            <td className="align-middle">
                {
                    inspection.clientsignedwaiver
                    ?
                        inspection.clientsignedwaiver instanceof File
                        ?
                            <a href={URL.createObjectURL(inspection.clientsignedwaiver)} target="_blank" rel="noopener noreferrer" className={styles.addedDoc}>
                                View File
                            </a>
                        :
                            <Button type="button" title="Download File" aria-label="Download File" variant="link" className={styles.addedDoc} onClick={() => downloadFile({FileID: inspection.clientsignedwaiver.id},'DownloadBidInspectionFile',inspection.clientsignedwaiver.name)}>
                                View File
                            </Button>
                    :   
                        <>N/A</>
                }
            </td>
            <td className="align-middle">{selectedWaiverStatus}</td>
            <td className="align-middle">{inspection.lastmodifieddate}</td>
            <td className="align-middle">{inspection.lastmodifiedbyuser}</td>
            <td className="align-middle">
                <div className="d-flex justify-content-around">
                    <div>
                        <Button size="sm" type="button" variant="primary" className="me-1" title="Edit Row" aria-label="Edit Row" onClick={toggleMode}>
                            <FontAwesomeIcon icon={faPenToSquare} />
                        </Button>
                    </div>
                    <div>
                        <Button size='sm' type="button" variant="danger" title="Remove Item" aria-label="Remove Item" onClick={() => remove(inspection.id)}>
                            <FontAwesomeIcon icon={faTrashCan} />
                        </Button>
                    </div>
                </div>
            </td>
        </tr>
    )
}

const EditMode = ({toggleMode,inspection,update,ActionTypes = [],InspectionStatuses = [],InspectionTypes = []}) => {
    const inspectionReportRef = useRef(null);
    const [inspectionReport,setInspectionReport] = useState(null);
    
    const waiverRef = useRef(null);
    const [waiverUpload,setWaiverUpload] = useState(null);
    
    const _handleInspectionReportFileClick = () => {
        if(inspectionReportRef?.current){
            inspectionReportRef.current.click();
        }
    }
    
    const _handleInspectionReportFileChange = (e) => {
        setInspectionReport(e.target.files[0]);
    
        inspectionReportRef.current.value = '';
    }
    
    const _handleWaiverFileClick = () => {
        if(waiverRef?.current){
            waiverRef.current.click();
        }
    }
    
    const _handleWaiverFileChange = (e) => {
        setWaiverUpload(e.target.files[0]);
    
        waiverRef.current.value = '';
    }
    
    const {handleSubmit,register,reset} = useForm();

    const _handleSubmit = (values) => {
        const updateVals = {
            id: inspection.id,
            inspectiontype: values[`inspectiontype${inspection.id}`],
            inspectiondate: values[`inspectiondate${inspection.id}`],
            inspectionstatus: values[`inspectionstatus${inspection.id}`],
            inspectionreport: inspectionReport,
            comments: values[`comments${inspection.id}`],
            clientsignedwaiver: waiverUpload,
            waiverstatus: values[`waiverstatus${inspection.id}`],
            lastmodifieddate: inspection.lastmodifieddate,
            lastmodifiedby: inspection.lastmodifiedby
        }

        update(inspection.id,updateVals);
        toggleMode();
    }

    useEffect(() => {
        const {id,inspectionreport,clientsignedwaiver,...rest} = inspection;


        const resetVal = {};
        resetVal[`inspectiontype${id}`] = rest.inspectiontype;
        resetVal[`inspectiondate${id}`] = rest.inspectiondate;
        resetVal[`inspectionstatus${id}`] = rest.inspectionstatus;
        resetVal[`comments${id}`] = rest.comments;
        resetVal[`waiverstatus${id}`] = rest.waiverstatus;

        setInspectionReport(inspectionreport);
        setWaiverUpload(clientsignedwaiver);
        reset(resetVal);
    },[])

    const downloadFile = useFileDownload();

    return(
        <tr>
            <td className="align-middle">
                {
                    InspectionTypes.map((item) => (
                        <label key={item.id} className="d-block">
                            <input type="radio" {...register(`inspectiontype${inspection.id}`)} value={item.id} />
                            {item.name}
                        </label>
                    ))
                }
            </td>
            <td className="align-middle">
                <input type="date" {...register(`inspectiondate${inspection.id}`)} style={{width: '100%'}}/>
            </td>
            <td className="align-middle">
                {
                    InspectionStatuses.map((item) => (
                        <label key={item.id} className="d-block">
                            <input type="radio" {...register(`inspectionstatus${inspection.id}`)} value={item.id} />
                            {item.name}
                        </label>
                    ))
                }
            </td>
            <td className="align-middle">
                {
                        inspectionReport
                        ?
                            inspectionReport instanceof File
                            ?
                                <div className='d-flex align-items-center'>
                                    <a href={URL.createObjectURL(inspectionReport)} target="_blank" rel="noopener noreferrer" className={styles.addedDoc}>
                                        View File
                                    </a>
                                    <ButtonOverride type="button" className={`${styles.deleteAddedButton} ms-2`} aria-label="Remove Document" title="Remove Document" onClick={() => setInspectionReport(null)}>
                                        <FontAwesomeIcon icon={faMultiply} size="lg" style={{color: 'red'}}/>
                                    </ButtonOverride>
                                </div>
                            :
                                <div className='d-flex align-items-center'>
                                    <Button type="button" title="Download File" aria-label="Download File" variant="link" className={styles.addedDoc} onClick={() => downloadFile({FileID: inspectionReport.id},'DownloadBidInspectionFile',inspectionReport.name)}>
                                        View File
                                    </Button>
                                    <ButtonOverride type="button" className={`${styles.deleteAddedButton} ms-2`} aria-label="Remove Document" title="Remove Document" onClick={() => setInspectionReport(null)}>
                                        <FontAwesomeIcon icon={faMultiply} size="lg" style={{color: 'red'}}/>
                                    </ButtonOverride>
                                </div>
                        :
                            <Button id="bidupload" type="button" variant="success" onClick={_handleInspectionReportFileClick} aria-label="Add Document(s)" title="Add Document(s)" className={`ms-1 ${styles.addFileButtonZ} ${styles.smallz}`} style={smallAddButtonStyle}>
                                <FontAwesomeIcon icon={faPlus} />
                            </Button>
                }
                <input ref={inspectionReportRef} type="file" style={{display: 'none'}} multiple={false} onChange={_handleInspectionReportFileChange}/>
            </td>
            <td className="align-middle">
                <textarea rows={2} placeholder="Comments" {...register(`comments${inspection.id}`)} />
            </td>
            <td className="align-middle">
                {
                        waiverUpload
                        ?
                            waiverUpload instanceof File
                            ?
                                <div className='d-flex align-items-center'>
                                    <a href={URL.createObjectURL(waiverUpload)} target="_blank" rel="noopener noreferrer" className={styles.addedDoc}>
                                        View File
                                    </a>
                                    <ButtonOverride type="button" className={`${styles.deleteAddedButton} ms-2`} aria-label="Remove Document" title="Remove Document" onClick={() => setWaiverUpload(null)}>
                                        <FontAwesomeIcon icon={faMultiply} size="lg" style={{color: 'red'}}/>
                                    </ButtonOverride>
                                </div>
                            :
                                <div className='d-flex align-items-center'>
                                    <Button type="button" title="Download File" aria-label="Download File" variant="link" className={styles.addedDoc} onClick={() => downloadFile({FileID: waiverUpload.id},'DownloadBidInspectionFile',waiverUpload.name)}>
                                        View File
                                    </Button>
                                    <ButtonOverride type="button" className={`${styles.deleteAddedButton} ms-2`} aria-label="Remove Document" title="Remove Document" onClick={() => setWaiverUpload(null)}>
                                        <FontAwesomeIcon icon={faMultiply} size="lg" style={{color: 'red'}}/>
                                    </ButtonOverride>
                                </div>
                        :
                        <Button id="bidupload" type="button" variant="success" onClick={_handleWaiverFileClick} aria-label="Add Document(s)" title="Add Document(s)" className={`ms-1 ${styles.addFileButtonZ} ${styles.smallz}`} style={smallAddButtonStyle}>
                            <FontAwesomeIcon icon={faPlus} />
                        </Button>
                            
                }
                <input ref={waiverRef} type="file" style={{display: 'none'}} multiple={false} onChange={_handleWaiverFileChange}/>
            </td>
            <td className="align-middle">
                {
                    ActionTypes.map((item) => (
                        <label key={item.id} className="d-block">
                            <input type="radio" {...register(`waiverstatus${inspection.id}`)} value={item.id} />
                            {item.name}
                        </label>
                    ))
                }
            </td>
            <td className="align-middle">{inspection.lastmodifieddate}</td>
            <td className="align-middle">{inspection.lastmodifiedby}</td>
            <td className="align-middle">
                <div className="d-flex align-items-center">
                    <ButtonOverride type="button" className='me-2 p-0' title="Save Changes" aria-label="Save Changes" onClick={handleSubmit(_handleSubmit)}>
                        <FontAwesomeIcon icon={faSave} size="lg" style={{ color: '#0d6efd' }} />
                    </ButtonOverride>
                    <ButtonOverride type="button" className='ms-2 p-0' title="Cancel Changes" aria-label="Cancel Changes" onClick={toggleMode}>
                        <FontAwesomeIcon icon={faMultiply} size="lg" />
                    </ButtonOverride>
                </div>
            </td>
        </tr>
    )
}

const InspectionItem = ({Inspection, ActionTypes = [],InspectionStatuses = [],InspectionTypes = [],update,remove}) => {
    const [editMode,setEditMode] = useState(false);

    const _toggleMode = () => setEditMode(!editMode);

    return(
        <>
            {
                editMode
                ?
                    <EditMode
                        toggleMode={_toggleMode}
                        inspection={Inspection}
                        ActionTypes={ActionTypes}
                        InspectionStatuses={InspectionStatuses}
                        InspectionTypes={InspectionTypes}
                        update={update}
                    />
                :
                    <ViewMode
                        toggleMode={_toggleMode}
                        inspection={Inspection}
                        ActionTypes={ActionTypes}
                        InspectionStatuses={InspectionStatuses}
                        InspectionTypes={InspectionTypes}
                        remove={remove}
                    />
            }
        </>
    )
}

export default InspectionItem;
